exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".viewPanelContentWrapper_1noNGfaIu2aYo4eST7ezLG {\n  padding: 0 40px;\n}\n\n.viewPanelContentWrapper_1noNGfaIu2aYo4eST7ezLG .section_KxnNqcank20udAcJEn3Na {\n  clear: both;\n  margin-bottom: 15px;\n}\n\n.viewPanelContentWrapper_1noNGfaIu2aYo4eST7ezLG .infoText_19p5nH59Kpd5b9TVp9n1_h {\n  clear: both;\n  margin-bottom: 15px;\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"viewPanelContentWrapper": "viewPanelContentWrapper_1noNGfaIu2aYo4eST7ezLG",
	"section": "section_KxnNqcank20udAcJEn3Na",
	"infoText": "infoText_19p5nH59Kpd5b9TVp9n1_h"
};